export default "__VITE_ASSET__CEdO4xOt__"